import React, { useCallback } from 'react'
import { NavLink } from 'react-router-dom'
import { Icons } from '@trr/common-component-library'
import classNames from 'classnames'
import { isLinkExternal } from '@local/src/Utils/Helpers'
import { toggleArbetsgivareCookie } from '@trr/app-shell-communication'
import { INavigationRoute } from '@local/src/App.types'

import s from './SubMenu.module.scss'

interface ISubMenuProps {
  onClose: () => void
  route: INavigationRoute
  testSelector: string
}

const SubMenu: React.FunctionComponent<ISubMenuProps> = ({
  onClose,
  route,
  testSelector,
}) => {
  const onNavLinkClicked = useCallback(
    (url: string) => () => {
      toggleArbetsgivareCookie(url)
      onClose()
    },
    [onClose]
  )

  return (
    <ul className={s.List}>
      <li>
        <NavLink
          href={route.url}
          to={route.url}
          className={classNames(s.Link)}
          onClick={onNavLinkClicked(route.url)}
        >
          <div className={classNames(s.NavItem, s.NavHeader)}>{route.name}</div>
        </NavLink>
      </li>
      {route.children?.map(({ name: childName, url: childUrl }) => (
        <React.Fragment key={`child${childUrl.toString()}`}>
          <li>
            {isLinkExternal(childUrl) ? (
              <a
                href={childUrl}
                className={classNames(s.Link, s.Inactive)}
                data-testid={`${testSelector}-${childName}`}
                rel="noreferrer"
                target="_blank"
              >
                <div className={classNames(s.NavItem, s.NavSubLink)}>
                  <Icons.LinkIcon size={16} />
                  {childName}
                </div>
              </a>
            ) : (
              <NavLink
                href={childUrl}
                to={childUrl}
                className={classNames(s.Link, s.Inactive)}
                activeClassName={s.Active}
                onClick={onNavLinkClicked(route.url)}
                data-testid={`${testSelector}-${childName}`}
              >
                <div className={classNames(s.NavItem, s.NavSubLink)}>
                  {childName}
                </div>
              </NavLink>
            )}
          </li>
        </React.Fragment>
      ))}
    </ul>
  )
}

export default SubMenu

/*
<ul className={s.List}>
{routes
  .filter((r) => isRoleActive(r.name))
  .map(({ name, url, children }) => (
    <React.Fragment key={`parent${url.toString()}`}>
      <li>
        <NavLink
          href={url}
          to={url}
          className={classNames(s.NavItem, s.NavHeader)}
          onClick={onNavLinkClicked(url)}
        >
          {name}
        </NavLink>
      </li>
      {children?.map(({ name: childName, url: childUrl }) => (
        <React.Fragment key={`child${childUrl.toString()}`}>
          <li>
            {isLinkExternal(childUrl) ? (
              <a
                href={childUrl}
                className={classNames(
                  s.NavItem,
                  s.NavSubLink,
                  s.Inactive
                )}
              >
                {childName}
              </a>
            ) : (
              <NavLink
                href={childUrl}
                to={childUrl}
                className={classNames(
                  s.NavItem,
                  s.NavSubLink,
                  s.Inactive
                )}
                activeClassName={s.Active}
                onClick={onNavLinkClicked(url)}
              >
                {childName}
              </NavLink>
            )}
          </li>
        </React.Fragment>
      ))}
    </React.Fragment>
  ))}
</ul>
*/
